module.exports = __webpack_public_path__ + "static/img/30-Affordable-homes.7702e40d.jpg";